import React, { useState } from "react";
import { Link } from "react-router-dom";
import AkkhorLayout from "../layout/akkhor";

// Hướng dẫn làm bài kiểm tra / bài tập cho học sinh (end user).
// Ảnh minh họa trong public/huong-dan-learning-hocsinh/.

const quyTrinh = [
  {
    id: "h1",
    title: "Bước 1: Mở danh sách bài của bạn",
    intro: "Tất cả bài kiểm tra / bài tập được giao cho bạn nằm ở đây.",
    links: [{ label: "Bài kiểm tra của tôi", to: "/bai-kiem-tra" }],
    steps: [
      "Vào menu Learning Hub > Bài kiểm tra của tôi.",
      "Mỗi thẻ là một bài. Bài chưa làm có nút Làm bài (①); bài đã làm có nút Xem kết quả (②) kèm điểm và trạng thái.",
      "Bấm Làm bài để bắt đầu.",
    ],
    image: "/huong-dan-learning-hocsinh/01-bai-cua-toi.png",
    caption: "Danh sách bài của bạn: ① nút Làm bài (bài chưa làm), ② nút Xem kết quả (bài đã làm).",
  },
  {
    id: "h2",
    title: "Bước 2: Làm bài và nộp",
    intro: "Trả lời lần lượt các câu hỏi rồi nộp bài.",
    links: [],
    steps: [
      "Đọc từng câu và chọn / nhập câu trả lời: trắc nghiệm (chọn ô tròn hoặc ô vuông), sắp xếp (kéo thả các mục theo đúng thứ tự), nối cột (chọn tương ứng), tự luận (gõ nội dung).",
      "Bài tự động lưu nháp khi bạn thao tác (dòng \"Đã lưu nháp\" phía trên). Nếu lỡ tải lại trang hay mất mạng, bài làm dở vẫn được giữ.",
      "Nếu bài có thời gian, đồng hồ đếm ngược hiển thị ở góc trên; hết giờ hệ thống tự nộp.",
      "Trả lời xong, bấm Nộp bài (②) và xác nhận.",
    ],
    image: "/huong-dan-learning-hocsinh/02-lam-bai.png",
    caption: "Màn làm bài: ① thông báo tự động lưu nháp, ② nút Nộp bài.",
    note: "Câu sắp xếp sẽ được xáo trộn thứ tự khi hiển thị — bạn kéo thả (hoặc dùng nút lên/xuống) để sắp lại cho đúng.",
  },
  {
    id: "h3",
    title: "Bước 3: Xem kết quả",
    intro: "Sau khi nộp, bạn xem được điểm và đáp án đúng/sai.",
    links: [{ label: "Bài kiểm tra của tôi", to: "/bai-kiem-tra" }],
    steps: [
      "Hệ thống chấm ngay phần trắc nghiệm; nếu có câu tự luận, trạng thái là Chờ chấm cho tới khi giáo viên chấm xong.",
      "Xem tổng điểm (①), từng câu đúng/sai và đáp án đúng, cùng nhận xét của giáo viên (nếu có).",
    ],
    image: "/huong-dan-learning-hocsinh/03-ket-qua.png",
    caption: "Màn kết quả: ① điểm tổng; bên dưới là chi tiết đúng/sai từng câu.",
  },
];

export default function HuongDanLearningHocSinh() {
  const [open, setOpen] = useState("h1");
  const toggle = (id) => setOpen(open === id ? "" : id);

  return (
    <AkkhorLayout idrole="dashboard">
      <div className="breadcrumbs-area">
        <ul>
          <li><Link to="/">Trang chủ</Link></li>
          <li>Hướng dẫn học viên</li>
        </ul>
      </div>

      <div className="card height-auto mb-3">
        <div className="card-body">
          <div className="heading-layout1">
            <div className="item-title">
              <h3 className="mb-0">
                <span className="fas fa-user-graduate mr-2" style={{ color: "#28a745" }} />
                Hướng dẫn học viên
              </h3>
            </div>
          </div>
          <p className="mb-2">
            Hướng dẫn cách <b>vào làm bài</b>, <b>nộp bài</b> và <b>xem kết quả</b> trong module LearningHub.
          </p>
          <p className="mb-0" style={{ color: "#888" }}>
            Vào menu <b>Learning Hub &gt; Bài kiểm tra của tôi</b> để bắt đầu.
          </p>
        </div>
      </div>

      <div className="card height-auto mb-3">
        <div className="card-body">
          <h4 className="mb-3"><span className="fas fa-list-ol mr-2" style={{ color: "#28a745" }} />Các bước làm bài</h4>
          {quyTrinh.map((qt) => {
            const isOpen = open === qt.id;
            return (
              <div key={qt.id} style={{ border: "1px solid #eee", borderRadius: 8, marginBottom: 10, overflow: "hidden" }}>
                <div onClick={() => toggle(qt.id)} style={{ cursor: "pointer", padding: "12px 15px", background: isOpen ? "#eafaef" : "#f7f7f7", display: "flex", alignItems: "center", fontWeight: 600 }}>
                  <span className={isOpen ? "fas fa-chevron-down mr-2" : "fas fa-chevron-right mr-2"} style={{ color: "#28a745", fontSize: 13 }} />
                  {qt.title}
                </div>
                {isOpen && (
                  <div style={{ padding: "14px 18px" }}>
                    <p style={{ color: "#666", fontSize: 13.5 }}>{qt.intro}</p>
                    {qt.links && qt.links.length > 0 && (
                      <div style={{ marginBottom: 10 }}>
                        {qt.links.map((l, i) => (
                          <Link key={i} to={l.to} className="btn-fill-sm btn-gradient-yellow btn-hover-bluedark mr-2" style={{ fontSize: 12.5 }}>
                            <span className="fas fa-external-link-alt mr-1" />{l.label}
                          </Link>
                        ))}
                      </div>
                    )}
                    <ol style={{ paddingLeft: 18, fontSize: 13.5, lineHeight: 1.7 }}>
                      {qt.steps.map((s, i) => <li key={i}>{s}</li>)}
                    </ol>
                    {qt.image && (
                      <figure style={{ margin: "12px 0 4px" }}>
                        <a href={qt.image} target="_blank" rel="noopener noreferrer">
                          <img src={qt.image} alt={qt.caption || qt.title} style={{ width: "100%", maxWidth: 1000, border: "1px solid #e3e3e3", borderRadius: 8, boxShadow: "0 2px 8px rgba(0,0,0,.08)", display: "block" }} />
                        </a>
                        {qt.caption && (
                          <figcaption style={{ fontSize: 12.5, color: "#888", marginTop: 6, fontStyle: "italic" }}>
                            <span className="fas fa-camera mr-1" />{qt.caption} (Bấm ảnh để xem lớn.)
                          </figcaption>
                        )}
                      </figure>
                    )}
                    {qt.note && (
                      <div style={{ background: "#fff8e1", border: "1px solid #ffe0a3", borderRadius: 6, padding: "8px 12px", fontSize: 12.5, color: "#8a6d00", marginTop: 8 }}>
                        <span className="fas fa-lightbulb mr-1" />{qt.note}
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </AkkhorLayout>
  );
}
